import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Sparkles } from "lucide-react";
import { api, reviewServiceLabel } from "../lib/api";

export default function Recensioni() {
  const [reviews, setReviews] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/reviews")
      .then((r) => setReviews(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const avg = reviews.length ? reviews.reduce((s, r) => s + r.rating, 0) / reviews.length : 0;

  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-14 sm:py-20" data-testid="recensioni-page">
      <div className="text-center mb-12">
        <p className="eyebrow">Le vostre parole</p>
        <h1 className="font-display text-3xl sm:text-4xl text-amber-100 mt-3">Recensioni</h1>
        {reviews.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 mt-5" data-testid="recensioni-summary">
            <div className="flex gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className={`w-5 h-5 ${i < Math.round(avg) ? "text-amber-400 fill-amber-400" : "text-purple-300/25"}`} />
              ))}
            </div>
            <span className="text-amber-200 font-medium" data-testid="recensioni-average">{avg.toFixed(1)}</span>
            <span className="text-purple-300/60 text-sm" data-testid="recensioni-count">· {reviews.length} {reviews.length === 1 ? "recensione" : "recensioni"}</span>
          </div>
        )}
      </div>

      {loaded && reviews.length === 0 ? (
        <div className="mystic-card p-10 text-center max-w-xl mx-auto" data-testid="recensioni-empty-state">
          <Star className="w-8 h-8 text-amber-400/60 mx-auto mb-4" />
          <p className="text-purple-200/70">Le recensioni verranno pubblicate qui.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div key={r.id} className="mystic-card p-7" data-testid={`review-full-card-${r.id}`}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-1">
                  {Array.from({ length: r.rating }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
                  ))}
                </div>
                {r.service && (
                  <span className="text-[10px] uppercase tracking-wider text-purple-300/60 border border-[#4a2175] rounded-full px-2 py-0.5">
                    {reviewServiceLabel(r.service)}
                  </span>
                )}
              </div>
              <p className="text-purple-100/80 text-sm leading-relaxed italic">“{r.text}”</p>
              <p className="text-amber-300 text-sm mt-4 font-medium">{r.author}</p>
              {r.reply && (
                <div className="mt-4 pt-3 border-t border-[#4a2175]/50" data-testid={`review-reply-${r.id}`}>
                  <p className="text-[10px] uppercase tracking-widest text-amber-300/80 mb-1">Risposta di Virginia</p>
                  <p className="text-purple-100/70 text-xs leading-relaxed">{r.reply}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="text-center mt-16" data-testid="recensioni-cta">
        <div className="h-px w-24 mx-auto bg-amber-500/20 mb-10" />
        <Link
          to="/#metodi"
          data-testid="recensioni-cta-btn"
          className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 text-amber-200 px-8 py-3.5 text-sm tracking-wide hover:bg-amber-500/10 hover:border-amber-400/60 transition-colors"
        >
          <Sparkles className="w-4 h-4" /> Prova anche tu una lettura
        </Link>
      </div>
    </div>
  );
}
